/* eslint-disable */

import { profileService } from '@/_services'
import { EventBus } from '@/event-bus.js'
import api from '@/_api'

export const [IDLE, FETCHING, PATCHING, DONE] = Array(4).keys()

const state = {
  items: [],
  item: null,
  stylist: null,
  status: IDLE,
  statusTimeout: null,
  assignment: {},
  assignedLoading: false,
  teamStats: [],
  salesOverviewStats: [],
  itemStats: null,
  itemStatsLoading: false,
  itemSalesOverviewLoading: false,
  count: 0,
}

const actions = {
  /** Fetch all visible profiles's stats by range. */
  fetchStats({ commit }, range) {
    commit('setStatus', FETCHING)
    profileService.getAllProfilesStats(range).then((response) => {
      commit('setStatus', DONE)
      commit('updateTeamStats', response.data.results)
    })
  },
  /** Fetch specific profile stats by range */
  fetchItemStats({ commit }, {id, range}) {
    commit('setItemStatsLoading', true)
    profileService.getProfileStats(id, range).then((response) => {
      commit('updateItemStats', response.data.activity_stats)
    }).finally(() => {
      commit('setItemStatsLoading', false)
    })
  },
  fetchAll({ commit }, kwargs = null) {
    commit('setStatus', FETCHING)
    profileService.getItems(kwargs).then((response) => {
      commit('setStatus', DONE)
      commit('updateData', response.data)
    })
  },
  addAllOrdered({ commit }, kwargs = null) {
    commit('setStatus', FETCHING)
    profileService.getOrderedItems(kwargs).then((response) => {
      commit('updateCount', response.data.count)
      commit('addItemPage', response.data.results)
    })
  },
  fetchItem({ commit }, id) {
    commit('reset')
    commit('setItemStatsLoading', true)
    profileService.getItem(id).then((response) => {
      commit('updateProfile', response.data)
    }).finally(() => {
      commit('setItemStatsLoading', false)
    })
  },
  patchItem({ commit }, payload) {
    commit('setStatus', PATCHING)
    profileService.patchItem(payload.pk, payload).then((response) => {
      commit('updateProfile', response.data)
    }).catch((e) => {
      console.error(e)

			let detail = '';
			if(!e.response || !e.response.data) {
				detail = 'Could not update profile'
			}

			if(e.response.data.detail) {
				detail = e.response.data.detail
			}

			if(Object.keys(e.response.data).length) {
				detail = e.response.data[Object.keys(e.response.data)[0]].join(';\n')
			}

      EventBus.$emit('toast-error', detail)
    }).finally(() => {
      commit('setStatus', DONE)
    })
  },
  fetchStylist({ commit }, id) {
    commit('reset')
    profileService.getItem(id).then((response) => {
      commit('updateStylist', response.data)
    })
  },
  addStylist({ commit }, payload) {
    return profileService.postItem(payload).then((response) => {
    })
  },
  heartbeat({ commit }, id) {
    profileService.heartbeat(id).then((response) => {
    })
  },
  addPage({ commit }, args = null) {
    profileService.getItems(args).then((response) => {
      commit('addItemPage', response.data.results)
      return response
    })
  },
  patchProfileImage({ commit, dispatch }, { id, image }) {
    const formData = new FormData();

    // This is solving a backend caveat
    const randomName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    formData.append('image', image, `avatar-${randomName}.jpg`);

    return api.patch(`/profile/${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => {
      commit('updateProfileImage', response.data);
    });
  },
  deleteProfileImage({ commit }, { id }) {
    profileService.patchItem(id, {
      image: null,
      image_url: null,
    }).then((response) => {
      commit('updateProfileImage', response.data);
    })
  },
  updateProfileImage({ commit }, response) {
    commit('updateProfileImage', response.data)
  },
  fetchSalesOverviewData({ commit }, id) {
    commit('setStatus', FETCHING)
    commit('setItemSalesOverviewLoading', true)
    return profileService.getSalesOverviewData(id).then((response) => {
      if (response.data.url) {
        return response
      } else {
        commit('setSalesOverviewStats', response.data)
        commit('setStatus', DONE)
        return response
      }
    }).finally(() => {
      commit('setItemSalesOverviewLoading', false)
    })
  },
  fetchCustomSalesOverviewData({ commit }, { url, range, external_id }) {
    commit('setItemSalesOverviewLoading', true)
    const payload = {
      range: range,
      external_id: external_id,
    };
    return profileService.getCustomSalesOverviewData(url, payload).then((response) => {
      commit('setSalesOverviewStats', response.data)
    }).finally(() => {
      commit('setStatus', DONE)
      commit('setItemSalesOverviewLoading', false)
    })
  },
  fetchTeam({commit}, url) {
    commit('setAssignmentStatus', true)
    profileService.fetchTeam(url).then((response) => {
      commit('setAssignment', response.data)
    }).finally(() => {
      commit('setAssignmentStatus', false)
    })
  },
  reset({ commit }) {
    commit('reset');
  },
  customReset({ commit }) {
    commit('customReset');
  },
}

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  customReset: (state) => {
    state.items = [];
    state.stylist = null;
    state.status = IDLE;
    state.statusTimeout = null;
    state.assignment = {};
    state.teamStats = [];
    state.salesOverviewStats = [];
    state.itemStats = null;
    state.itemStatsLoading = false;
    state.count = 0;
  },
  reset: (state) => {},
  addItemPage(state, items) {
    state.items.push(...items)
  },
  updateData(state, items) {
    state.items = items.results,
    state.count = items.count
  },
  updateTeamStats(state, itemStats) {
    state.teamStats = itemStats
  },
  updateItemStats(state, itemStats) {
    state.itemStats = itemStats
  },
  setItemStatsLoading(state, isLoading) {
    state.itemStatsLoading = isLoading
  },
  setItemSalesOverviewLoading(state, isLoading) {
    state.itemSalesOverviewLoading = isLoading
  },
  updateProfile(state, item) {
    state.item = item
  },
  updateStylist(state, item) {
    state.stylist = item
  },
  updateProfileImage(state, item) {
    state.item.profile_pic = item.profile_pic
    state.item.image = item.image
    state.item.image_url = item.image_url
  },
  updateCount(state, count) {
    state.count = count;
  },
  setSalesOverviewStats(state, items) {
    state.salesOverviewStats = items
  },
  setAssignment(state, item) {
    state.assignment = item;
  },
  setAssignmentStatus(state, boolean) {
    state.assignedLoading = boolean;
  },
  setStatus(state, value) {
    if (state.statusTimeout) {
      // Cancel any previous timeout
      clearTimeout(state.statusTimeout)
      state.statusTimeout = null
    }

    // Set status
    state.status = value

    // Set timeout from DONE to IDLE
    if (value === DONE) {
      state.statusTimeout = setTimeout(() => {
        state.statusTimeout = null
        state.status = IDLE
      }, 500)
    }
  },
}

export const profiles = {
  namespaced: true,
  state,
  actions,
  mutations,
}
